module.exports = __webpack_public_path__ + "img/white-dm0max-000.a9ab9725.png";